import Component from '../core/Component'
import { queryAll, toggleClass } from '../utils/dom'
import EventBus from '../core/EventBus'
import { queries } from '../core/config'
import enquire from 'enquire.js'

export const STATES = {
    ACTIVE: 'is-active'
}

const defaults = {
    media: ''
}

export default class Tabs extends Component {

    static SILENT = true

    constructor(element) {
        super(element, defaults)

        this.ref = {
            progress: null,
            items: [],
            panels: []
        }

        this.current = null

        this.tabs = []
        this.panels = {}

        this.enquireHandler = {
            match: this.attach,
            unmatch: this.detach
        }

        if (this.element.dataset.media) {
            this.options.media = this.element.dataset.media
        }

        if (this.options.media) {
            this.options.media = queries?.[this.options.media] || this.options.media
        }
    }

    prepare() {
        if (this.options.media) {
            enquire.register(this.options.media, this.enquireHandler)
        } else {
            this.attach()
        }

    }

    destroy() {
        if (this.options.media) {
            enquire.unregister(this.options.media, this.enquireHandler)
        } else {
            this.detach()
        }
    }

    attach = () => {
        this.panels = this.ref.panels
            .reduce((acc, element) => {
                acc[element.id] = {
                    id: element.id,
                    element: element
                }

                element.removeAttribute('id')
                return acc
            }, {})

        this.tabs = this.ref.items
            .map(element => {
                const anchor = element.querySelector('a')
                const panelId = anchor.href.split('#')[1]

                element.addEventListener('click', event => {
                    if (panelId in this.panels) {
                        event.preventDefault()
                        this.show(panelId)
                    }
                })

                return {
                    panelId,
                    element
                }
            })

        const fragment = window.location.hash.replace('#', '')

        if (fragment && fragment in this.panels) {
            this.show(fragment, Tabs.SILENT)
        } else {
            let defaultTab = this.tabs.find(tab => tab.element.classList.contains(STATES.ACTIVE))

            if (!defaultTab) {
                defaultTab = this.tabs[0]
            }

            this.show(defaultTab.panelId, Tabs.SILENT)
        }

        EventBus.on('tabs:show', this.handleTabsShow)
    }

    detach = () => {
        Object.keys(this.panels).forEach(key => this.panels[key].element.id = key)
        EventBus.off('tabs:show', this.handleTabsShow)
    }

    handleTabsShow = ({ panelId }) => {
        this.show(panelId)
    }

    show(panelId, silent = false) {

        if (!(panelId in this.panels)) {
            return
        }

        if (panelId === this.current) {
            return
        }

        this.current = panelId

        Object.keys(this.panels).forEach(key => toggleClass(this.panels[key].element, STATES.ACTIVE, this.panels[key].id === panelId))

        this.tabs.forEach(tab => toggleClass(tab.element, STATES.ACTIVE, tab.panelId === panelId))

        const activeTab = this.tabs.find(tab => tab.id === panelId)

        if (this.ref.progress) {
            if (activeTab && activeTab.offsetParent) {
                const link = this.ref.links.find(element => activeTab.contains(element))

                const parentBox = activeTab.offsetParent.getBoundingClientRect()
                const linkBox = link.getBoundingClientRect()
                const activeBox = activeTab.getBoundingClientRect()

                this.ref.progress.style.top = `${linkBox.top - parentBox.top + linkBox.height/2}px`
                this.ref.progress.style.height = `${activeBox.height}px`
            } else {
                this.ref.progress.style.height = '0px'
            }
        }

        if (this.options.anchors && !silent){
            window.location.hash = panelId
        }

        const panel = this.panels[panelId]

        this.emit('change', {
            panelId,
            panel
        })

        EventBus.emit('tabs:change', {
            panelId,
            panel
        })

        return this

    }
}
